import { useState } from 'react'
import { useAppDispatch, useAppSelector } from '../store/hooks'
import { setAppName, setAppDescription, setBaseBranch, submitRequest } from '../store/requestSlice'
import './DescribeAppForm.css'

function DescribeAppForm() {
  const dispatch = useAppDispatch()
  const { appName, appDescription, baseBranch, submitting, error } = useAppSelector(
    (state) => state.request,
  )
  const [submitted, setSubmitted] = useState(false)

  const nameEmpty = appName.trim().length === 0
  const descriptionEmpty = appDescription.trim().length === 0

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    setSubmitted(true)
    if (nameEmpty || descriptionEmpty || submitting) return
    dispatch(
      submitRequest({
        name: appName.trim(),
        description: appDescription.trim(),
        baseBranch: baseBranch.trim() || undefined,
      }),
    )
  }

  return (
    <form className="describe-app-form" data-testid="describe-app-form" noValidate onSubmit={handleSubmit}>
      <h2 className="describe-app-form__title">Describe Your App</h2>

      {error && (
        <div className="describe-app-form__error" data-testid="describe-app-form-error" role="alert">
          {error}
        </div>
      )}

      <div className="describe-app-form__field">
        <label className="describe-app-form__label" htmlFor="app-name" data-testid="app-name-label">
          App Name
        </label>
        <input
          id="app-name"
          className="describe-app-form__input"
          data-testid="app-name-input"
          type="text"
          placeholder="e.g. Inventory Tracker Pro"
          value={appName}
          onChange={(e) => dispatch(setAppName(e.target.value))}
          aria-required="true"
          aria-invalid={submitted && nameEmpty ? true : undefined}
          aria-describedby={submitted && nameEmpty ? 'app-name-error' : undefined}
        />
        {submitted && nameEmpty && (
          <span className="describe-app-form__field-error" data-testid="app-name-error" id="app-name-error" role="alert">
            App Name is required
          </span>
        )}
      </div>

      <div className="describe-app-form__field">
        <label className="describe-app-form__label" htmlFor="app-description" data-testid="app-description-label">
          Description
        </label>
        <textarea
          id="app-description"
          className="describe-app-form__textarea"
          data-testid="app-description-input"
          placeholder="Describe what the app should do..."
          rows={4}
          value={appDescription}
          onChange={(e) => dispatch(setAppDescription(e.target.value))}
          aria-required="true"
          aria-invalid={submitted && descriptionEmpty ? true : undefined}
          aria-describedby={submitted && descriptionEmpty ? 'app-description-error' : undefined}
        />
        {submitted && descriptionEmpty && (
          <span className="describe-app-form__field-error" data-testid="app-description-error" id="app-description-error" role="alert">
            Description is required
          </span>
        )}
      </div>

      <div className="describe-app-form__field">
        <label className="describe-app-form__label" htmlFor="base-branch" data-testid="base-branch-label">
          Base Branch <span className="describe-app-form__optional">(optional)</span>
        </label>
        <input
          id="base-branch"
          className="describe-app-form__input"
          data-testid="base-branch-input"
          type="text"
          placeholder="e.g. loop-builder-base (defaults to global setting)"
          value={baseBranch}
          onChange={(e) => dispatch(setBaseBranch(e.target.value))}
        />
      </div>

      <button
        type="submit"
        className="describe-app-form__submit"
        data-testid="describe-app-form-submit"
        aria-disabled={submitting}
      >
        {submitting ? 'Submitting...' : 'Submit Request'}
      </button>
    </form>
  )
}

export default DescribeAppForm
